module.exports = __webpack_public_path__ + "media/images/static/consult/img03-b6d78efcdf42f5fafcf472dfa6da375b.png";